import type { MultiLevelOption } from '../types'

export const findMultiLevelOptionPath = (
  options: MultiLevelOption[],
  optionId: string | null | undefined,
  path: MultiLevelOption[] = [],
): MultiLevelOption[] => {
  if (!optionId) return []

  for (const option of options) {
    const nextPath = [...path, option]

    if (option.id === optionId) {
      return nextPath
    }

    if (option.children?.length) {
      const found = findMultiLevelOptionPath(option.children, optionId, nextPath)

      if (found.length) {
        return found
      }
    }
  }

  return []
}
